import { setOnboardingActive_actionType } from "../constants";

const initialState = {
  active: false,
};

const onboardingReducer = (state = initialState, action) => {
  switch (action.type) {
    case setOnboardingActive_actionType:
      return {
        ...state,
        active: action.payload,
      };
    default:
      return state;
  }
};

export default onboardingReducer;
